/**
 * Utility functions for formatting template names and related data
 */

/**
 * Formats a template name from snake_case to Title Case
 * Example: "home_value_1" becomes "Home Value 1"
 *
 * @param templateName The template name to format
 * @returns The formatted template name
 */
export const formatTemplateName = (templateName: string): string => {
  if (!templateName || templateName === '-') return '-';

  // Split by underscore and capitalize each word
  return templateName
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
